import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Nursery } from '../../components/economicsphere/ui/nursery';
// import {Apps} from '~/features/apps';
// import {AppHeader} from '~/widgets/ui';
// import {withTariff} from '~/shared/lib/hoc/with-tariff';
// import compose from 'compose-function';
// Приложения страница
const NurseryPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Питомники</title>
            </Helmet>
            <Nursery/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default NurseryPage
